/**
 * Created by OLD on 21/09/2015.
 */
define('registerMain',[
  'module',
  'logger',
  'registerMainRouter'
], function(
  module,
  Logger
) {
  'use strict';

  var Register = {
    start: function() {
      Logger.log(module, 'starting LoginModule');
    },

    stop: function() {
      Logger.log(module, 'stopping LoginModule');
    }
  };

  module.exports = Register;
});
